import type { WsMessage } from "@/api/websocket";

/** Account-wide chat updates are shared; automatic desktop actions are local. */
export function isRemoteDeviceAction(message: WsMessage): boolean {
  if (message.device_local !== false) return false;
  return (
    message.type.startsWith("cursor.") ||
    message.type.startsWith("desktop.") ||
    message.type.startsWith("onboarding.") ||
    message.type.startsWith("permission.") ||
    message.type.startsWith("awaiting_input.") ||
    message.type === "canvas.presentation_sequence" ||
    message.type === "project.switch_requested" ||
    message.type === "space.switch_requested" ||
    message.type === "execution.resource" ||
    message.type === "execution.deferred" ||
    message.type === "execution.warning" ||
    message.type === "runtime.state" ||
    message.type === "billing.onscreen_limit_exceeded"
  );
}
